<template>
  <v-dialog scrollable persistent v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-tooltip left v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="showButton"
            v-on="on"
            dark
            small
            fab
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar serviço</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeForm">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-4 pb-0">
        <span class="title grey--text text--darken-2">
          {{ formTitle }}
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <v-form
          ref="jobForm"
          v-model="validForm"
          lazy-validation
          class="mt-0 pt-0"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-menu
                v-model="valDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="true"
                    v-model="start_date_formated"
                    label="Data inicio"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    return-masked-value
                    mask="##/##/####"
                    :rules="$store.state.formRules.required"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="formData.start_date"
                  @input="valDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12>
              <v-select
                :items="serviceTypeItems"
                label="Tipo de serviço"
                v-model="formData.service_type"
                :rules="$store.state.formRules.required"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                v-model="formData.description"
                label="Descrição"
                :rules="$store.state.formRules.required"
                required
                maxlength="1000"
              ></v-textarea>  
            </v-flex>

            <v-flex xs12>
              <v-select
                :items="criticalityItems"
                label="Criticidade"
                v-model="formData.criticality_level"
                :rules="$store.state.formRules.required"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <v-menu
                v-model="deadlineDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="term_date_formated"
                    label="Prazo"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    return-masked-value
                    mask="##/##/####"
                    :rules="$store.state.formRules.required"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="formData.term"
                  @input="deadlineDate = false"
                  :min="minimunDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions style="border-top: 1px solid #eee">
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="closeForm"
          >Cancelar</v-btn
        >
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as moment from 'moment'
import { serviceType } from '@/services/checklists'

const defaultJOpenJob = () => {
  return {
    start_date: new Date().toISOString().substr(0, 10),
    service_type: "",
    description: "",
    criticality_level: "",
    term: new Date().toISOString().substr(0, 10)
  }
}

export default {
  name: 'JobFormDlg',

  props: {
    showButton: Boolean,
    dialog: Boolean,
    openForm: Function,
    closeForm: Function,
    jobId: Number,
    editFormData: Object,
    editActivityIndex: Number,
  },

  data () {
    return {
      criticalityItems: [
        "Crítico",
        "Alto",
        "Médio",
        "Baixo"
      ],
      serviceTypeItems: [],
      responsibleDialog: false,
      valDate: false,
      deadlineDate: false,
      viewForm: false,
      validForm: true,
      formData: defaultJOpenJob(),
    }
  },

  computed: {
    start_date_formated: {
      get () {
        return this.formData.start_date
          ? moment(this.formData.start_date).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.start_date = new Date().toISOString().substr(0, 10)
            return
          }
          this.formData.start_date = date
        } else {
          this.formData.start_date = ''
        }
      }
    },

    term_date_formated: {
      get () {
        return this.formData.term
          ? moment(this.formData.term).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.formData.term = new Date().toISOString().substr(0, 10)
            return
          }
          this.formData.term = date
        } else {
          this.formData.term = ''
        }
      }
    },

    minimunDate() {
      const date = this.start_date_formated.split('/')

      return `${date[2]}-${date[1]}-${date[0]}`
    },

    formTitle() {
      if (this.editFormData) return "Editar serviço"

      return "Adicionar serviço"
    }
  },

  watch: {
    dialog (edit) {   
      if (edit) {
        // do something
        this.getServiceTypes()

        if (this.editFormData) {
          this.formData = { ...this.editFormData }
        }
      } else {
        this.$refs.jobForm.resetValidation()
        this.formData = defaultJOpenJob()
        this.viewForm = false
      }
    }
  },

  methods: {
    async getServiceTypes () {
      this.serviceTypeItems = await serviceType()
    },

    doSave () {
      if (!this.$refs.jobForm.validate()) {
        return
      }

      let payload = { id: this.jobId, data: this.formData, edit: this.editFormData ? true : false, activityIndex: this.editFormData ? this.editActivityIndex : null }

      this.$emit('newJob', payload)

      this.$refs.jobForm.resetValidation()

      this.closeForm()
    },

    resetDialog () {
      this.$refs.jobForm.resetValidation()
      this.dialogShow = !this.dialogShow
    }
  }
}
</script>

<style>
.labelIcon {
  position: absolute;
  left: 3px;
  top: 15px;
  cursor: pointer;
}
.labelIcon i {
  font-size: 18px;
}
.iptFile input {
  opacity: 0;
}
.imgBox {
  overflow: hidden;
  display: flex;
  width: 200px;
  height: 200px;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.delImage {
  font-size: 18px;
  color: #c62828 !important;
  cursor: pointer;
}
.addressCondominium .flex {
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
}
#condominiumTab .v-tabs__bar {
  border-bottom: 1px solid #eee !important;
}

#condominiumTab .v-tabs__item.tabError {
  color: #c62828;
}
#condominiumTab .v-tabs__item.tabError::before {
  content: "*";
  color: #c62828;
}
</style>
